import React from "react";
import { Space, Input, Select, Button, Form } from "antd";
import { useTranslation } from "react-i18next";

import "../../../public/sass/components/_filters.scss";

const { Option } = Select;
const { Search } = Input;

export const Filters = ({
  companies,
  handleFilter,
  handleGetAllClients,
  search,
  setSearch,
}) => {
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm();

  const clearFilters = () => {
    form.resetFields();
    handleGetAllClients();
    setSearch(false);
  };

  // return null;
  return (
    <div className="wrapper">
      <Space direction="horizontal" className="filters">
        <Form
          form={form}
          id="users-filters"
          layout="inline"
          scrollToFirstError
          onFinish={handleFilter}
        >
          <Form.Item name="company">
            <Select
              showSearch={true}
              searchBy="label"
              optionFilterProp="children"
              placeholder={t("company")}
              className="min-width-select-component"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) === 0
              }
            >
              {companies?.map((item, idx) => (
                <Option key={idx} value={item?.id}>
                  {item?.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="status">
            <Select
              name="status"
              showSearch={true}
              searchBy="label"
              optionFilterProp="children"
              placeholder="Status"
              className="min-width-select-component"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) === 0
              }
            >
              <Option value={0}>{t("active")}</Option>
              <Option value={1}>{t("nicht_akzeptiert")}</Option>
              <Option value={2}>{t("in_bearbeitung")}</Option>
              <Option value={3}>{t("done")}</Option>
              <Option value={4}>{t("nicht_aktiv")}</Option>
            </Select>
          </Form.Item>

          <Button
            type="primary"
            form="users-filters"
            key="submit"
            htmlType="submit"
          >
            Filter
          </Button>
          {search && (
            <Button onClick={clearFilters} className="button-style">
              {t("clear_filter")}
            </Button>
          )}
        </Form>
      </Space>
    </div>
  );
};
